let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bJlGM")).then(() => parcelRequire('4hIWy'));